define.alias("shared/models/ig-user", "calendar/models/ig-user");